import { createSelector } from 'reselect';

import {
  activeFlagColumnDefinition,
  clientsColumnDefinition,
  emailColumnDefinition,
  firstNameColumnDefinition,
  lastNameColumnDefinition,
  ssoColumnDefinition,
  lastLoginColumnDefinition,
  createdByColumnDefinition,
  createdOnColumnDefinition,
} from '../columnDefinitions';
import {
  editUserSettingsColumnDefinitionFactory,
} from '../columnDefinitionGenerators';

export const USER_SETTINGS_DEFAULT_COLSPAN = 7;

const getColumnDefs = ({
  addingNewUser,
  loggedInUserSso,
  canEditHimself,
  canEditUsers,
  isUserModified,
  confirmModalData,
  userToEditSso,
  readOnly,
  showUserSettingsFormForEdit,
  showConfirmDialogModal,
  hideConfirmDialogModal,
}) => [
  editUserSettingsColumnDefinitionFactory({
    addingNewUser,
    loggedInUserSso,
    canEditHimself,
    canEditUsers,
    isUserModified,
    confirmModalData,
    userToEditSso,
    readOnly,
    showUserSettingsFormForEdit,
    showConfirmDialogModal,
    hideConfirmDialogModal,
  }),

  emailColumnDefinition,
  firstNameColumnDefinition,
  { ...lastNameColumnDefinition, sort: 'asc' },
  ssoColumnDefinition,
  activeFlagColumnDefinition,
  clientsColumnDefinition,
  createdByColumnDefinition,
  createdOnColumnDefinition,
  lastLoginColumnDefinition,
];

export default createSelector(
  addingNewUser => addingNewUser,
  loggedInUserSso => loggedInUserSso,
  canEditHimself => canEditHimself,
  canEditUsers => canEditUsers,
  isUserModified => isUserModified,
  confirmModalData => confirmModalData,
  userToEditSso => userToEditSso,
  readOnly => readOnly,
  showUserSettingsFormForEdit => showUserSettingsFormForEdit,
  showConfirmDialogModal => showConfirmDialogModal,
  hideConfirmDialogModal => hideConfirmDialogModal,
  getColumnDefs
);
